// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"webgiving-main-header__container___23BuT"};
    if(module.hot) {
      // 1745450291619
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  